import { createSlice } from '@reduxjs/toolkit'
import { fetchHomeDataThunk, makeFetchSlice } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import {
  fetchSubscriptions,
  fetchSubscriptionCredits,
  SubscriptionCreditsParams,
} from 'features/home/api'
import {
  SELECTED_SUBSCRIPTION_PLAN_REDUCER_NAME,
  SUBSCRIPTIONS_LIST_REDUCER_NAME,
  SUBSCRIPTIONS_CREDIT_REDUCER_NAME,
} from 'features/home/consts'
import { mapStripeSubscriptionToPlan } from 'features/home/utils'
import { createSetupIntents } from './api'
import { SETUP_INTENT_REDUCER_NAME } from './consts'

import { SubscriptionPlan } from './types'

const setupIntentSlice = makeFetchSlice(SETUP_INTENT_REDUCER_NAME)
export const setupIntentReducer = setupIntentSlice.reducer
export const setupIntentActions = setupIntentSlice.actions

export const createSetupIntentThunk = (rootDomainId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const res = await fetchHomeDataThunk({
        dispatch,
        actions: setupIntentActions,
        asyncFunc: () => createSetupIntents(rootDomainId),
      })

      return res
    } catch (error) {
      console.log(`Error while creating Stripe's SetupIntent`, error)
    }
  }
}

const subscriptionsListSlice = makeFetchSlice(SUBSCRIPTIONS_LIST_REDUCER_NAME)

export const subscriptionsListReducer = subscriptionsListSlice.reducer
export const subscriptionsListActions = subscriptionsListSlice.actions

export const fetchSubscriptionsThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchHomeDataThunk({
        dispatch,
        actions: subscriptionsListActions,
        asyncFunc: () => fetchSubscriptions(homeId),
      })
    } catch (error) {
      console.log('Error getting subscriptions', error)
    }
  }
}

const subscriptionPlansSlice = createSlice({
  initialState: {} as SubscriptionPlan,
  name: SELECTED_SUBSCRIPTION_PLAN_REDUCER_NAME,
  reducers: {
    setSelectedPlan: (_, action) => action.payload,
  },
  extraReducers: {
    [subscriptionsListActions.succeed.toString()]: (state, { payload }) => {
      const subscriptionPlan = mapStripeSubscriptionToPlan(payload)
      return subscriptionPlan
    },
  },
})

export const subscriptionPlansReducer = subscriptionPlansSlice.reducer
export const subscriptionPlansActions = subscriptionPlansSlice.actions

const subscriptionsCreditSlice = makeFetchSlice(
  SUBSCRIPTIONS_CREDIT_REDUCER_NAME
)

export const subscriptionsCreditReducer = subscriptionsCreditSlice.reducer
export const subscriptionsCreditActions = subscriptionsCreditSlice.actions

export const fetchSubscriptionCreditsThunk = (
  homeId: string,
  params: SubscriptionCreditsParams
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchHomeDataThunk({
        dispatch,
        actions: subscriptionsCreditActions,
        asyncFunc: () => fetchSubscriptionCredits(homeId, params),
      })
    } catch (error) {
      console.log('Error getting subscription credits', error)
    }
  }
}
